import { useCallback, useMemo, useState } from "react";
import { useGroupedTableInternal } from "../utils";
import { GroupedTableEmbeddedToolbarProps } from "./GroupedTableEmbeddedToolbar.types";
import { UnstyledButton } from "src/ui";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import classNames from "classnames";

function GroupedTableEmbeddedToolbar(_: GroupedTableEmbeddedToolbarProps): JSX.Element {
    const [expanded, setExpanded] = useState(false);
    const { api } = useGroupedTableInternal();

    const extraButtons = useMemo(() => {
        if (!expanded) {
            return null;
        }

        return (<>
            <UnstyledButton className="button"
                            onClick={api.expandOneLevel}>
                <Visage2Icon className="icon"
                             icon="arrow-down"
                             size="small" />
            </UnstyledButton>
            <UnstyledButton className="button"
                            onClick={api.collapseOneLevel}>
                <Visage2Icon className="icon"
                             icon="arrow-up-3"
                             size="small" />
            </UnstyledButton>
            <UnstyledButton className="button"
                            onClick={api.expandAll}>
                <Visage2Icon className="icon"
                             icon="data"
                             rotation={90}
                             size="small" />
            </UnstyledButton>
        </>);
    }, [expanded, api]);

    const toggleExpanded = useCallback(() => setExpanded((e) => !e), []);

    return (
        <div className={classNames("GroupedTableEmbeddedToolbar", { "expanded": expanded })}>
            <UnstyledButton className="expand-button button"
                            onClick={toggleExpanded}>
                <Visage2Icon className="expand-icon"
                             color={expanded ? "neutralBlue" : "spintrGrey"}
                             icon="setting-4"
                             rotation={-90}
                             size="small" /> 
            </UnstyledButton>
            {extraButtons}
        </div>
    );
}

export default GroupedTableEmbeddedToolbar;
